import React, { useState } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'

import './AccordionList.scss'

export const AccordionList = ({ elements }) => {

  let activeElement = 0;
  elements.find((el, index) => {
    if (el.active) {
      activeElement = index
      return true
    }
  })

  const [panelKey, setPanelKey] = useState(activeElement)

  const handleChangePanel = (key) => setPanelKey(key)

  return (<div className='ljr-accordion-list'>
    <PanelGroup
      accordion
      activeKey={panelKey}
      onSelect={handleChangePanel}
    >
      {
        elements.map((elem, key) => (
          <Panel key={key} eventKey={key}>
            <Panel.Heading className={`${panelKey === key ? 'active' : ''} `}>
              <Panel.Title toggle>
                {elem.title}
                <i className={`arrow-icon fa fa-angle-${panelKey === key ? 'up' : 'down'}`} />
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <div className='text-content'>
                {elem.content}
              </div>
            </Panel.Body>
          </Panel>
        ))
      }
    </PanelGroup>
  </div>)
}


// WEBPACK FOOTER //
// ./src/features/commons/AccordionList/AccordionList.component.js